import { useSuspenseQuery } from '@tanstack/react-query';
import { useCurrentOrganizationId } from '#organizations/hooks/use-current-organization-id';
import { organizationCoreQueries } from '../api';

/**
 * Hook to get the current organization's core data (id, name, slug, status, etc.).
 * Returns domain-typed ApiOrganization from api-kit.
 *
 * Cache is populated by organization-manager or the domain orchestrator.
 */
export function useCurrentOrganizationCore() {
  const id = useCurrentOrganizationId();
  const { data } = useSuspenseQuery(organizationCoreQueries.detail(id));
  return data;
}
